export default function SmallLineIcon({ className }: { className?: string }) {
	return (
		// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
		<svg
			width="42"
			height="2"
			viewBox="0 0 42 2"
			fill="none"
            className={className}
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M1 1H41"
				stroke="currentColor"
				stroke-width="2"
				stroke-linecap="round"
				stroke-dasharray="5 5"
			/>
		</svg>
	);
}
